<script>
import {setSeoOnWrapper} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

export default {
  name: "SingleContentWrapper",
  props: {
    contentLink: {
      default: null,
    },
    activeRouteWatch: {
      default: true,
    }
  },
  data() {
    return {
      content: []
    }
  },
  methods: {
    async initWrapper() {
      if (this.contentLink == null) {
        this.content = await this.$store.dispatch("Content/getContentWithoutState", this.$route.params.slug)
        await this.$emit('content', this.content)
      } else {
        this.content = await this.$store.dispatch("Content/getContentWithoutState", this.contentLink)
        await this.$emit('content', this.content)
      }
    }
  },
  render() {
    return this.$slots.default({
      content: this.content.data !== undefined ? this.content.data.data : []
    });
  },
  async mounted() {

    await this.initWrapper()

    setSeoOnWrapper(this.content.data.data, 'content')

  },
  watch: {
    '$route': {
      handler: function () {
        if (this.activeRouteWatch) {
          const routeName = this.$route.name;
          if (routeName == 'SinglePage' || routeName == 'SinglePost') {
            this.initWrapper();
          }
        }
      },
    },
  }
}
</script>
